// NAME-STRING → LUCIDE COMPONENT LOOKUP, for every taxonomy that stores an
// icon as a Lucide component name in `meta.icon`. This shim resolves the
// string back to a component reference at render time; `iconByName()` falls
// back to `MessageCircle` for an unknown or typo'd name.
//
// BRIEF 137 §5 — THE HEADER IS REWRITTEN RATHER THAN AMENDED, because it
// argued from a mechanism that no longer exists. It read "The chat_message_type
// taxonomy stores icons as Lucide component names", which was this file's whole
// stated reason for being (M+3.6 C5) — and 137 §5 retires that taxonomy from the
// UI. A note appended under the old sentence would have left the file
// explaining itself by a kind nothing reads any more, which is the same failure
// 99 withdrew 91 §3b for and 107 §2b withdrew a claim in `CaseEventRow` for.
//
// WHO IT SERVES NOW, and why deleting or trimming it would have been wrong:
//
//   · external_link (Phase 14) — the curated ~30-icon set. Admins type the
//     Lucide name as free text in `meta.icon` for the External resources page
//     (Avocats.be / OVB, Belgian DPA, Ministry of Justice, National Bank of
//     Belgium, Moniteur belge, …).
//   · event_status (136 §3) — `CircleQuestionMark` and `CircleOff`, the two
//     glyphs an event status may put in place of the day counter. Approved
//     the evening before 137 was written, which is exactly why §5 fences this
//     file: a retirement that trimmed the registry to "the chat entries are
//     gone" would have broken a feature signed off an hour earlier.
//
// THE ORIGINAL M+3.6 NAMES STAY, ALL OF THEM. They are not chat's property:
// the registry is keyed by Lucide name, any taxonomy's `meta.icon` may name
// any of them, and `ICON_NAMES` is what an admin picker offers. Removing the
// fifteen that chat happened to introduce would narrow every OTHER kind's
// choices to pay for a kind that left.

import {
  MessageCircle,
  Phone,
  AlertCircle,
  AlertTriangle,
  CheckSquare,
  Activity,
  Gavel,
  Info,
  Bell,
  Calendar,
  FileText,
  Mail,
  Video,
  Users,
  Briefcase,
  // Phase 14 — External resources set.
  Scale,
  Landmark,
  ShieldCheck,
  Newspaper,
  Building2,
  Globe,
  BookOpen,
  Banknote,
  Coins,
  BookOpenCheck,
  Library,
  Lock,
  ExternalLink,
  Search,
  GraduationCap,
  // BRIEF 136 §3 — the two glyphs an event status may put in place of the day
  // counter. Lucide's own names, checked against the version this tree pins
  // (lucide-react 1.7.0): both resolve, and neither has moved.
  CircleQuestionMark,
  CircleOff,
} from "lucide-react";

const REGISTRY: Record<string, any> = {
  MessageCircle,
  Phone,
  AlertCircle,
  AlertTriangle,
  CheckSquare,
  Activity,
  Gavel,
  Info,
  Bell,
  Calendar,
  FileText,
  Mail,
  Video,
  Users,
  Briefcase,
  Scale,
  Landmark,
  ShieldCheck,
  Newspaper,
  Building2,
  Globe,
  BookOpen,
  Banknote,
  Coins,
  BookOpenCheck,
  Library,
  Lock,
  ExternalLink,
  Search,
  GraduationCap,
  // 136 §3
  CircleQuestionMark,
  CircleOff,
};

// Sorted list of registered icon names — handy for admin pickers / hints.
export const ICON_NAMES = Object.keys(REGISTRY).sort();

export function iconByName(name: string) {
  return REGISTRY[name] || MessageCircle;
}
